module.exports = __webpack_public_path__ + "static/img/KG.66941dbb.svg";